$(function() {
  //モバイルメニュー表示
   	$('#detail_menus .mobile-nav-toggle').click(function(){
      $('body').addClass("enable-mobile-nav-transition reveal-mobile-nav reveal-mobile-nav--revealed is-fixed");
      return false;
    });	  
  //ヘッダーの動き
  $(window).on('load resize', function() {
    const header = $('.section-header');
    const headerHeight = header.outerHeight();
    let beforeScrollTop = 0;

    if (window.matchMedia( "(max-width: 767px)" ).matches) {
      console.log("SP");
      header.removeClass("is-show");
      $(window).scroll(function () {
          const scrollTop = $(this).scrollTop();
          if((scrollTop > beforeScrollTop) && (scrollTop > headerHeight)) {
              header.addClass('is-hide');
          }
          else {
              header.removeClass('is-hide');
            header.removeClass('is-fixed');
          }
          beforeScrollTop = scrollTop;
      });
    }else{
      console.log("PC");
        header.removeClass('is-hide');
        header.removeClass('is-fixed');
        $(window).scroll(function () {
              if ($(this).scrollTop() > 10) {
                  header.addClass("is-show");
              } else {
                  header.removeClass("is-show");
              }
        });
    }
    
  });

    //検索窓表示
   	$('#detail_menus .show-search-link').click(function(){
      $('body').addClass("show-search");
      return false;
    });	

  //スライダーサムネイル  
  const mySwiper_thumb = new Swiper('#product-left-gallery .swiper-thumb', {
      spaceBetween: 6,
      slidesPerView: 'auto',
      grabCursor: true,
      navigation: {
        nextEl: '#product-left-gallery .thum-next',
        prevEl: '#product-left-gallery .thum-prev',
      },
		breakpoints: {
			768: {
			  direction: 'vertical',
			}
		}      

  });
  //スライダー
  const mySwiper_main = new Swiper('#product-left-gallery .swiper-main', {
      loop: false,
      lazy: false,
    　autoHeight: false,
      navigation: {
        nextEl: '#product-left-gallery .button-next',
        prevEl: '#product-left-gallery .button-prev',
      },
      thumbs: {
          swiper: mySwiper_thumb,
      },
      slidesPerView: 1,
      effect: 'fade',
      breakpoints: {
          768: {
            autoHeight: false,
          }
      }      

  });
  mySwiper_main.on('slideChange', () => {
      mySwiper_thumb.slideToLoop(mySwiper_main.realIndex);
  });
  mySwiper_thumb.on('slideChange', () => {
      mySwiper_main.slideToLoop(mySwiper_thumb.realIndex);
  });

  //カラバリクリック時スライド操作
  	$('.opt-label--image.slide-click').click(function(){
      var hash = "." + $(this).attr('id');
      var index = $(hash).index('#product-left-gallery .swiper-main .swiper-slide');
      mySwiper_main.slideTo(index);
    });	


	$('.acdn_head').click(function(){
		$(this).toggleClass("is-open");
		$(this).next(".acdn_content").slideToggle();
	});	

  var sizeTxt = $('.option-selector:nth-of-type(2) .option-selector__btns input:checked').val();
  console.log(sizeTxt);
  $('.js-size').text(sizeTxt);

     $( '.option-selector:nth-of-type(2) .option-selector__btns input' ).change( function() {
      var sizeTxt = $('.option-selector:nth-of-type(2) .option-selector__btns input:checked').val();
       $('.js-size').text(sizeTxt);
   }); 


})
